import React from "react";
import { observer } from "mobx-react";
import { Tooltip } from "antd";
import "./style/shrinked-chat-list.scoped.scss";
import { useChatAgeSort } from "./use-chat-age-sort";

export const ShrinkedChatList = observer(({ chats, activeChat, onOpen }) => {
    const [recent, older] = useChatAgeSort(chats);

    return (
        <div className="shrinked-chat-list">
            <div className="list">
                <div className="group-title">Recent Chats</div>

                {recent.map((chat) => {
                    return (
                        <div
                            key={chat._id}
                            className={`chat ${chat._id === activeChat ? "active" : ""}`}
                            onClick={() => onOpen(chat._id)}
                        >
                            <Tooltip title={chat.name} placement="bottom" mouseEnterDelay={0.5}>
                                <span className="name">{chat.name}</span>
                            </Tooltip>
                        </div>
                    );
                })}

                <div className="group-title">Older Chats</div>

                {older.map((chat) => {
                    return (
                        <div
                            key={chat._id}
                            className={`chat ${chat._id === activeChat ? "active" : ""}`}
                            onClick={() => onOpen(chat._id)}
                        >
                            <Tooltip title={chat.name} placement="bottom" mouseEnterDelay={0.5}>
                                <span className="name">{chat.name}</span>
                            </Tooltip>
                        </div>
                    );
                })}

                {chats.length === 0 && <div className="no-chats">No previous chats.</div>}
            </div>
        </div>
    );
});
